
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/ispot-tv",
      function () {
        return require("private-next-pages/destinations/ispot-tv.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/ispot-tv"])
      });
    }
  